<template>
  <b-modal id="dispatchTaskModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmtask.dispatchTaskModalHeader') }}</h6>
      </b-col>
    </b-row>
    <Loader v-if="!task || loadingTechnicians"></Loader>
    <b-row v-else>
      <b-col cols="12">
        <div class="form-group">
          <label
                  for="userData"
                  class="form-control-label">{{$t('modals.excmtask.dispatchUserData')}}:</label>
          <fg-input>
            <el-select
                    id="userData"
                    class="select-default"
                    :placeholder="$t('modals.excmtask.dispatchUserData')"
                    filterable
                    :disabled="isServiceMan && !isSuperUser"
                    v-model="userData">
              <el-option v-for="option in technicianOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.fullName"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
      <b-col cols="6" v-if="task.idTaskType && task.idTaskType.taskParams.canBeDailyPlanItem" >
        <label
          for="userData"
          class="form-control-label">{{$t('modals.excmtask.date')}}:</label>
        <fg-input>
          <el-date-picker
            :picker-options="{firstDayOfWeek: 1}"
            v-model="date"
            type="date">
          </el-date-picker>
        </fg-input>
      </b-col>
      <b-col cols="6" v-if="task.idTaskType && task.idTaskType.taskParams.canBeDailyPlanItem" >
        <label
          for="excmdailyplan_deletedAt"
          class="form-control-label">{{$t('modals.excmtask.timeStartOnCalendar')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('modals.excmtask.timeStartOnCalendar')"
                              v-model="timeStartOnCalendar"
                              format="HH:mm"
                              :right="true"
                              only-time
                              formatted="HH:mm"
        >
        </VueCtkDateTimePicker>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn variant="success" @click="dispatch()">{{ $t('buttons.submit') }}</b-btn>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { getUserRoles } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader'
import { ENTRYPOINT } from '@/config/entrypoint'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'DispatchTaskModal',
  components: {
    Loader,
    VueCtkDateTimePicker
  },
  computed: {
    ...mapGetters({
      updated: 'excmdispatchtask/update/updated'
      // task: 'excmtask/show/retrieved'
    }),
    isServiceMan () {
      return (getUserRoles().roles.includes('ROLE_SERVICEMAN') || getUserRoles().roles.includes('ROLE_EXTERNAL_SERVICEMAN'))
    },
    isSuperUser () {
      return !!getUserRoles().roles.includes('ROLE_SUPER_USER')
    },
    isDispatcher () {
      return !!getUserRoles().roles.includes('ROLE_DISPATCHER')
    },
    show () {
      return this.$store.state.modals.excmtask.dispatch.show
    },
    taskIRI () {
      return this.$store.state.modals.excmtask.dispatch.taskIRI
    },
    close () {
      return this.$store.state.modals.excmtask.dispatch.close
    },
    lastPoolTaskIRI () {
      return this.$store.state.modals.excmtask.dispatch.poolTaskIRI
    },
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    }
  },

  created () {
    // if (this.isServiceMan) this.setCurrentUser()
  },

  watch: {
    'updated' (val) {
      this.$store.state.modals.excmtask.dispatch.dispatched = 1
      this.closeModal()
    },
    'show': function (val) {
      this.getUserRoles()
      this.openModal()
      this.setCurrentUser()
    },
    'taskIRI': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      task: {},
      userData: null,
      User: {},
      date: this.$moment.now(),
      timeStartOnCalendar: '',
      technicianOptions: [],
      loadingTechnicians: true
    }
  },
  methods: {
    setCurrentUser () {
      if (!this.isDispatcher) {
        this.userData = this.path + 'user_datas/' + getUserRoles().id_userdata
      }
    },

    ...mapActions({
      dispatchTask: 'excmdispatchtask/update/dispatchTask',
      getTask: 'excmtask/show/retrieve',
      resetTask: 'excmtask/show/reset'
    }),

    getUserRoles () {
      this.User = getUserRoles()
    },
    openModal () {
      if (this.show === 1 && this.taskIRI) {
        this.getTaskData(this.taskIRI)
        // this.task = Object.assign({}, this.computedTask)
        this.$store.state.modals.excmtask.dispatch.show = 0
        this.$store.state.modals.excmtask.dispatch.task = null
        this.$bvModal.show('dispatchTaskModal')
      }
    },
    async dispatchPoolTask () {
      let id = this.getIdLink(this.task.lastPoolTask['@id'])
      let data = {
        operationTransferUserData: this.userData,
        operation: 3
      }
      await new ApiService(`e_x_c_m_pool_tasks/${id}`).put(data)
      this.$store.state.modals.excmtask.dispatch.dispatched = 1
      this.closeModal()
    },
    dispatch () {
      if (this.date && this.task.idTaskType.taskParams.canBeDailyPlanItem) {
        let params = {
          idUserData: parseInt(this.getIdLink(this.userData)),
          date: this.$moment(this.date).format('YYYY-MM-DD'),
          timeStartOnCalendar: this.timeStartOnCalendar,
          taskId: this.getIdLink(this.task['@id'])
        }
        this.dispatchTask(params)
      } else {
        this.dispatchPoolTask()
      }
    },
    getTaskData (iri) {
      this.getTask(iri)
    },
    async getTask (iri) {
      let id = getId(iri)
      this.task = await new ApiService(`e_x_c_m_tasks/${id}`).getResults()
      await this.getTechnicians()
    },
    async getTechnicians () {
      this.loadingTechnicians = true
      let params = { pagination: false, isCompany: 0, isContractor: 0 }
      if (this.task.idTaskType) {
        params.applicableForTaskType = this.task.idTaskType['@id']
      }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.technicianOptions = response.items
      this.loadingTechnicians = false
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmtask.dispatch.close = 0
      }
      this.$bvModal.hide('dispatchTaskModal')
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      this.userData = null
      this.date = this.$moment.now()
      this.timeStartOnCalendar = ''
      this.technicianOptions = []
      this.task = {}
      this.loadingTechnicians = true
    }
  }
}
</script>
